module.exports = __webpack_public_path__ + "img/eye-white.7631ff7e.svg";